/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_ProvisionInputs */

const cs_sreality_seller_provision = /** @type {(inputs: Sreality_Seller_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založit Sreality makléře pro tohoto uživatele`)
};

const en_sreality_seller_provision = /** @type {(inputs: Sreality_Seller_ProvisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Sreality seller for this user`)
};

/**
* | output |
* | --- |
* | "Create Sreality seller for this user" |
*
* @param {Sreality_Seller_ProvisionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_provision = /** @type {((inputs?: Sreality_Seller_ProvisionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_ProvisionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_provision(inputs)
	return cs_sreality_seller_provision(inputs)
});